import React from 'react'
import { ReadOnlyFieldDisplay } from '../../../components/ReadOnlyFieldDisplay'
import { MarketEnum, RouteTypeEnum, TradeFormValues } from '../Types'
import styles from './styles.module.less'

const AwayTradeFieldsPreview = ({
  values: { executingBroker, market, orderId, routeType },
}: {
  values: TradeFormValues
}) => {
  return (
    <div className={`away-trade-form-group-preview ${styles.awayTradeFieldsPreview}`}>
      <div className={styles.awayTradeFieldsPreviewRow}>
        <ReadOnlyFieldDisplay className="route-type-preview" label="Route Type" required value={routeType} />
        <ReadOnlyFieldDisplay className="order-id-preview" label="Order ID" value={orderId} />
      </div>
      {(routeType === RouteTypeEnum.Dma || routeType === RouteTypeEnum.Away) && (
        <div className={styles.awayTradeFieldsPreviewRow}>
          <ReadOnlyFieldDisplay className="market-preview" label="Market" required value={market} />
        </div>
      )}
      {market === MarketEnum.Otc && (
        <div className={styles.awayTradeFieldsPreviewRow}>
          <ReadOnlyFieldDisplay
            className="exec-broker-preview"
            label="Executing Broker (MPID)"
            required={routeType === RouteTypeEnum.Away && market === MarketEnum.Otc}
            value={executingBroker}
          />
        </div>
      )}
    </div>
  )
}

export default AwayTradeFieldsPreview
